import { render, staticRenderFns } from "./StoryTable.vue?vue&type=template&id=1499de90"
import script from "./StoryTable.vue?vue&type=script&lang=js"
export * from "./StoryTable.vue?vue&type=script&lang=js"
import style0 from "./StoryTable.vue?vue&type=style&index=0&id=1499de90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports